import { ShieldCheck, Shield, Globe, Award, MapPin } from "lucide-react";
import { TRUST_BADGES } from "../data/mock";

const iconMap = {
  ShieldCheck,
  Shield,
  Globe,
  Award,
  MapPin,
};

export const TrustBar = () => {
  return (
    <section className="relative py-8 sm:py-10 bg-[hsl(220,25%,97%)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-400 mb-5">Trusted & Verified</p>
        <div className="flex overflow-x-auto sm:overflow-visible sm:flex-wrap items-center justify-start sm:justify-center gap-3 lg:gap-5 pb-2 sm:pb-0 -mx-4 px-4 sm:mx-0 sm:px-0 scrollbar-hide">
          {TRUST_BADGES.map((badge, i) => {
            const Icon = iconMap[badge.icon];
            return (
              <div
                key={i}
                className="flex items-center gap-2.5 px-4 py-3 rounded-xl bg-white border border-slate-200/60 hover:border-hevi-blue/25 card-premium transition-all duration-400 group cursor-default shrink-0 sm:shrink"
              >
                <div className="w-8 h-8 rounded-lg bg-navy-50 flex items-center justify-center group-hover:bg-navy-100 transition-colors duration-300">
                  {Icon && <Icon size={15} className="text-hevi-blue" />}
                </div>
                <span className="text-xs font-semibold text-navy-800 whitespace-nowrap">
                  {badge.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
